import { IJPatientCreationModel, IPatientCreationModel } from "@/Common/Models/Patient/UI/IPatientCreationModel";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";

class SidebarActions extends BaseAction {
    constructor() {
        super();
    }

    public SearchPatients(query: string, isInactive: boolean, maxNumOfResults: number): void {
        var requestData = {
            Query: query,
            IsInactive: isInactive,
            IncludeRelatives: false,
            IncludePatients: true,
            ResultsToReturn: maxNumOfResults,
            OrderedResponseId: sidebarStore.currentSearchId
        };

        this.Execute(ServerOperations.Server.Myle_SearchIndividual, requestData);
    }

    public SearchPortalPatients(query: string): void {
        this.Execute(ServerOperations.Server.Portal_Proxy_SearchPatientProfiles, { Query: query, IncludeLinked: true });
    }

    public SearchRelatives(query: string, isInactive: boolean, maxNumOfResults: number): void {
        var requestData = {
            Query: query,
            IsInactive: isInactive,
            IncludeRelatives: true,
            IncludePatients: false,
            ResultsToReturn: maxNumOfResults,
            OrderedResponseId: sidebarStore.currentSearchId
        };
        this.Execute(ServerOperations.Server.Myle_SearchIndividual, requestData);
    }

    public CreateNewPatient(patientModel: IPatientCreationModel): void {
        let requestData: any = {
            SelectedPrefixLookupId: patientModel.get("SelectedPrefixLookupId"),
            FirstName: patientModel.get("FirstName"),
            LastName: patientModel.get("LastName"),
            PreferredName: patientModel.get("PreferredName"),
            PreferredPronouns: patientModel.get("PreferredPronouns"),
            SpecifiedPreferredPronouns: patientModel.get("SpecifiedPreferredPronouns"),
            GenderLookupId: patientModel.get("GenderLookupId"),
            GenderIdentity: patientModel.get("GenderIdentity"),
            DateOfBirth: patientModel.get("DOB")?.toDateOnly(),
            CivicAddress: patientModel.get("CivicAddressEdit"),
            City: patientModel.get("CityEdit"),
            PostalCode: patientModel.get("PostalCodeEdit"),
            NAM: patientModel.get("NAMEdit"),
            NAMExpiry: patientModel.get("NAMExpiryEdit"),
            Phone1Number: patientModel.get("Phone1Edit"),
            Phone1ContactTypeLookupId: patientModel.get("Phone1ContactTypeLookupId"),
            Phone1TypeLookupId: patientModel.get("Phone1TypeLookupId"),
            Phone1Ext: patientModel.get("Phone1Extension"),
            Phone1NotificationsEnabled: patientModel.get("Phone1NotificationsEnabled"),
            Phone2Number: patientModel.get("Phone2Edit"),
            Phone2ContactTypeLookupId: patientModel.get("Phone2ContactTypeLookupId"),
            Phone2TypeLookupId: patientModel.get("Phone2TypeLookupId"),
            Phone2Ext: patientModel.get("Phone2Extension"),
            Phone2NotificationsEnabled: patientModel.get("Phone2NotificationsEnabled"),
            CountryLookupId: patientModel.get("SelectedCountryLookupId"),
            RegionLookupId: patientModel.get("SelectedRegionLookupId"),
            HealthCardRegionLookupId: IJPatientCreationModel.getHealthCardRegionLookupId(patientModel),

            EmailAddress: patientModel.get("EmailEdit"),
            EmailTypeByLookup: patientModel.get("EmailTypeByLookup"),
            IsOkToContact: patientModel.get("IsOkToContact"),
            EmailNotificationsEnabled: patientModel.get("EmailNotificationsEnabled"),
            MotherLastName: patientModel.get("motherLastName"),
            MotherFirstName: patientModel.get("motherFirstName")
        };

        if (patientModel.get("representantEnabled") == true) {
            requestData.representantRelationType = patientModel.get("representantRelationType");
            requestData.representantType = patientModel.get("representantType");

            if (patientModel.get("representantPersonSelected") != null) {
                requestData.representantContactId = patientModel.get("representantPersonSelected").ContactId;
            }
            else {
                requestData.representantNAM = patientModel.get("representantNAM");
                requestData.representantFirstName = patientModel.get("representantFirstName");
                requestData.representantLastName = patientModel.get("representantLastName");
            }
        }

        this.Execute(ServerOperations.Server.Myle_CreatePatient, requestData);
    }

    public GetNoticeCounts(): void {
        if (!cacheStore.ClinicSettings.EnableCovidQuestionnaire)
            return;

        this.Execute(ServerOperations.Server.Myle_Questionnaire_GetQuestionnaireNoticeCounts, {});
    }
}

export { SidebarActions };
